import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import TitlePage from "../../Shared/TitlePage";
import { dataService } from "../../../Services/data/data.service";

import { parseNewDateToDDMMYYY } from "../../../Utils/dateHelper";
import PriceTable from "./Components/PriceTable";
import TableHighLow from "./Components/TableHighLow";
import EventChart from "./Components/EventChart";
import FinancialChart from "./Components/FinancialChart.jsx";
import TimeRangeChart from "../Results/Components/TimeRangeChart";
import Image from "../../../../src/Images/camera.svg";
import { Spin } from "react-cssfx-loading";
import pieChart from "../../../../src/Images/Pie.svg";
import { parseNewDateToDDMMYYYWithoutSeconds } from "../../../Utils/dateHelper";

import html2canvas from "html2canvas";
import { Divider, Button, Box } from "@mui/material";
import { Plus, Minus, CircleAlert, ChevronLeft, Factory, MapPin, DiamondPlus, Timer, TextCursorInput, List, ScanBarcode, LinkIcon } from "lucide-react";
import { externalApiTypes, controlTypes } from "../../../Config/constants.js";

function ProjectReportPage(props) {
  const classes = useStyles();
  const { projectQr } = useParams();

  const [project, setProject] = useState(null);
  const [priceData, setPriceData] = useState([]);
  const [currency, setCurrency] = useState(null);

  const [totalPrice, setTotalPrice] = useState(0);
  const [financialChartData, setFinancialChartData] = useState([]);
  const [projectDetailNames, setDetailsNames] = useState({});
  const [measurementRows, setMeasurementRows] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [timeRangeDates, setTimeRangeDates] = useState({
    fromDate: new Date(Date.now() - 86400000),
    startDate: new Date(Date.now() - 86400000),
    toDate: new Date(Date.now()),
    endDate: new Date(Date.now()),
  });
  const navigate = useNavigate();
  const ref = React.createRef();
  const HighLowRef = React.createRef();

  useEffect(() => {
    dataService.getProjectByProjectQr(projectQr).then((res) => {
      setProject(res);
      handleProject(res);
    });
  }, [projectQr]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (project) {
      dataService.getCurrencyById(project.currencyId).then((response) => {
        setCurrency(response);
      });
    }
  }, [project]);

  function convertHMS(value) {
    const sec = parseInt(value, 10); // convert value to number if it's string
    let hours = Math.floor(sec / 3600); // get hours
    let minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
    let seconds = sec - hours * 3600 - minutes * 60; //  get seconds
    // add 0 if value < 10; Example: 2 => 02
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return hours + ":" + minutes + ":" + seconds; // Return is HH : MM : SS
  }

  const handleProject = (project) => {
    let thisProject = project;
    let tempMeasurementsCollection = [];
    let chartMeasurementCollection = [];

    //Loop through all details and just toss all measurements together, afterwards flatten and sort by date
    for (let i = 0; i < thisProject.details.length; i++) {
      tempMeasurementsCollection.push(thisProject.details[i].measurements);
    }

    tempMeasurementsCollection = tempMeasurementsCollection.flat();
    tempMeasurementsCollection = tempMeasurementsCollection.sort((a, b) => new Date(a.insertedOn) - new Date(b.insertedOn));

    setMeasurementRows(tempMeasurementsCollection);
    //Get last measurement so we can decide the last date for the rangeslider
    let fromAndToDate = constructFromAndToDate(tempMeasurementsCollection);
    let tempToDate = fromAndToDate[1];
    let tempFromDate = fromAndToDate[0];

    chartMeasurementCollection = tempMeasurementsCollection.filter((x) => new Date(x.insertedOn) >= new Date(tempFromDate) && new Date(x.insertedOn) <= new Date(tempToDate));
    constructPriceData(thisProject, tempFromDate, tempToDate);
    setTimeRangeDates({ fromDate: tempFromDate, toDate: tempToDate, startDate: tempFromDate, endDate: tempToDate });

    let projectDetails = thisProject.details;
    //Creates an object with all detail and their color (needed for the chart)
    let detailNames = constructDetailCollection(projectDetails);

    //Construct the data that will be displayed in the financial chart
    let tempChartData = constructChartData(projectDetails, chartMeasurementCollection);

    setDetailsNames(detailNames);
    setFinancialChartData(tempChartData);
    setLoading(false);
  };

  const constructDetailCollection = (details) => {
    let temporaryCollection = [];
    for (let i = 0; i < details.length; i++) {
      let thisProjectDetail = details[i];
      if (thisProjectDetail.price > 0) {
        temporaryCollection.push({ name: thisProjectDetail.description, color: thisProjectDetail.color });
      }
    }
    //Empty array for all details, also add a total to display in the graph
    temporaryCollection.push({ name: "Total", color: "#c7c9c8" });

    return temporaryCollection;
  };

  const constructChartData = (projectDetails, chartDataCollection) => {
    let tempTotalData = [];
    let total = 0;
    let startTime = chartDataCollection.length > 0 ? chartDataCollection[0].insertedOn : new Date();
    let count = 0;

    //First we loop through all measurements to calculate the TOTAL LINE
    chartDataCollection.forEach((thisMeasurement) => {
      let isStopwatch = false;
      let isCount = true;
      let thisDetail = projectDetails.find((x) => x.id === thisMeasurement.projectDetailId);
      if (thisDetail !== undefined && thisMeasurement.price > 0) {
        if (thisDetail.controlTypeId === 2 || (thisDetail.controlTypeId === 7 && thisDetail.externalApiTypeId == externalApiTypes.STOPWATCH)) {
          isStopwatch = true;
        } else if (thisDetail.controlTypeId === controlTypes.EXTERNALAPI && thisDetail.externalApiTypeId == externalApiTypes.NUMERIC) {
          isCount = true;
        }

        let price_per = thisMeasurement.price !== null ? thisMeasurement.price : 0;
        let tempMeasurementData = {};
        var dif;
        var priceToAdd;
        if (isStopwatch) {
          let startDate = new Date(thisMeasurement.startValue);
          let stopDate = new Date(thisMeasurement.stopValue);
          if (stopDate > startDate) {
            dif = (stopDate.getTime() - startDate.getTime()) / 1000;
          } else {
            dif = 0;
          }
          priceToAdd = (thisMeasurement.price / 3600) * dif;
        } else if (isCount) {
          priceToAdd = thisMeasurement.numericValue * price_per;
        } else {
          priceToAdd = price_per;
        }
        if (thisDetail.isProfit === thisMeasurement.isNegative) {
          total -= priceToAdd;
        } else {
          total += priceToAdd;
        }
        if (count === 0) {
          tempMeasurementData = {
            id: thisMeasurement.id,
            measurement: "Total",
            date: startTime,
            price: 0,
            profitAdded: 0,
            isVisible: true,
            Total_price: 0,
            color: thisDetail.color,
            isProfit: thisDetail.isProfit,
            isNegative: thisMeasurement.isNegative,
            originalMeasurement: thisDetail.description,
          };
          tempTotalData.push(tempMeasurementData);
        }
        tempMeasurementData = {
          id: thisMeasurement.id,
          measurement: "Total",
          date: thisMeasurement.insertedOn,
          price: priceToAdd,
          profitAdded: priceToAdd,
          isVisible: true,
          Total_price: total,
          color: thisDetail.color,
          isProfit: thisDetail.isProfit,
          isNegative: thisMeasurement.isNegative,
          originalMeasurement: thisDetail.description,
        };
        tempTotalData.push(tempMeasurementData);
        count++;
      }
    });

    let tempDetailData = [];

    //Loop through the details and their measurements to get each unique detail line
    projectDetails
      .filter((x) => x.measurements && x.measurements.some((measurement) => measurement.price > 0))
      .forEach((thisDetail) => {
        let isStopwatch = false;
        let isCount = false;
        let detailCount = 0;

        if (thisDetail.controlTypeId === controlTypes.STOPWATCH || (thisDetail.controlTypeId === controlTypes.EXTERNALAPI && thisDetail.externalApiTypeId == externalApiTypes.STOPWATCH)) {
          isStopwatch = true;
        } else if (thisDetail.controlTypeId === controlTypes.EXTERNALAPI && thisDetail.externalApiTypeId == externalApiTypes.NUMERIC) {
          isCount = true;
        }

        let thisMeasurements = chartDataCollection.filter((x) => x.projectDetailId === thisDetail.id);

        let total = 0;
        let price_per = thisDetail.price !== null ? thisDetail.price : 0;
        let startTime = chartDataCollection.length > 0 ? chartDataCollection[0].insertedOn : new Date();

        if (thisMeasurements.length > 0) {
          let variablename = thisDetail.description + "_price";
          thisMeasurements.forEach((thisMeasurement) => {
            let tempMeasurementData = {};
            var dif;
            var priceToAdd;
            if (isStopwatch) {
              let startDate = new Date(thisMeasurement.startValue);
              let stopDate = new Date(thisMeasurement.stopValue);
              if (stopDate > startDate) {
                dif = (stopDate.getTime() - startDate.getTime()) / 1000;
              } else {
                dif = 0;
              }
              priceToAdd = (thisMeasurement.price / 3600) * dif;
            } else if (isCount) {
              priceToAdd = thisMeasurement.numericValue * price_per;
            } else {
              priceToAdd = price_per;
            }

            if (thisDetail.isProfit === thisMeasurement.isNegative) {
              total -= priceToAdd;
            } else {
              total += priceToAdd;
            }
            if (detailCount === 0) {
              tempMeasurementData = {
                detailCount: 0,
                id: thisMeasurement.id,
                measurement: thisDetail.description,
                date: startTime,
                price: 0,
                profitAdded: 0,
                isVisible: true,
                [variablename]: 0,
                color: thisDetail.color,
                isProfit: thisDetail.isProfit,
                isNegative: thisMeasurement.isNegative,
              };
              tempDetailData.push(tempMeasurementData);
            }
            tempMeasurementData = {
              id: thisMeasurement.id,
              measurement: thisDetail.description,
              date: thisMeasurement.insertedOn,
              price: priceToAdd,
              profitAdded: priceToAdd,
              isVisible: true,
              [variablename]: total,
              color: thisDetail.color,
              isProfit: thisDetail.isProfit,
              isNegative: thisMeasurement.isNegative,
            };
            tempDetailData.push(tempMeasurementData);
            detailCount++;
          });
        }
      });
    let combinedData = tempTotalData.concat(tempDetailData);
    return combinedData;
  };

  const constructPriceData = (thisProject, thisFromDate, thisToDate) => {
    let amountOfMeasurements = [];
    let detailDescriptions = [];
    let measurementColors = [];
    let tempMeasurementPrices = [];
    let tempPriceData = [];

    let total = 0;
    //Loop through details
    let projectDetails = thisProject.details;

    for (let i = 0; i < projectDetails.length; i++) {
      //If measurements have stopValue they are a stopwatch
      let thisDetail = projectDetails[i];
      let filteredMeasurements = thisDetail.measurements.filter((x) => new Date(x.insertedOn) >= new Date(thisFromDate) && new Date(x.insertedOn) <= new Date(thisToDate));
      if (filteredMeasurements.length > 0) {
        //events
        //Check if stopvalue than type 2 is stopwatch
        let detailType = null;
        if (filteredMeasurements[0].stopValue !== null) {
          detailType = 2; // stopwatch
        } else if (filteredMeasurements[0].externalApiTypeId === externalApiTypes.NUMERIC) {
          detailType = 3; // count
        } else {
          detailType = 1;
        }
        // filteredMeasurements[0].stopValue !== null ? 2 : 1;
        amountOfMeasurements.push(filteredMeasurements.length);
        detailDescriptions.push(projectDetails.description);
        measurementColors.push(projectDetails.color);
        tempMeasurementPrices.push({
          measurementId: filteredMeasurements[0].id !== 0 ? filteredMeasurements[0].id : filteredMeasurements[0].externalApiId,
          price: 0,
        });

        let lowestDate = new Date(filteredMeasurements[0].insertedOn);
        let totalMeasurementPrice = 0;
        let totalTime = 0;
        let tempTotal = 0;
        let tempAmount = 0;

        if (detailType === controlTypes.STOPWATCH || (detailType === controlTypes.EXTERNALAPI && filteredMeasurements[0].externalApiTypeId === externalApiTypes.STOPWATCH)) {
          // rewrite the above code so it's better and actually works correctly
          filteredMeasurements.forEach((measurement) => {
            let startDate = new Date(measurement.startValue);
            let stopDate = new Date(measurement.stopValue);

            let dif = 0;
            if (stopDate > startDate) {
              dif = (stopDate.getTime() - startDate.getTime()) / 1000;
            }

            totalTime += dif;
            totalMeasurementPrice += (measurement.price / 3600) * dif;
          });

          tempTotal = totalMeasurementPrice;
          tempAmount = totalTime;
        } else if (detailType === 3) {
          // measurements with isNegative should be subtracted from the total count
          let totalCount = filteredMeasurements.reduce((acc, x) => {
            if (x.isNegative) {
              return acc - x.numericValue;
            } else {
              return acc + x.numericValue;
            }
          }, 0);
          tempTotal = totalCount * thisDetail.price;
          tempAmount = totalCount;
        } else if (detailType === controlTypes.COUNTER) {
          let positiveMeasurements = filteredMeasurements.filter((x) => x.isNegative === false);
          let negativeMeasurements = filteredMeasurements.filter((x) => x.isNegative === true);

          let positiveTotal = positiveMeasurements.reduce((acc, x) => acc + x.price, 0);
          let negativeTotal = negativeMeasurements.reduce((acc, x) => acc + x.price, 0);

          tempTotal = positiveTotal - negativeTotal;
          tempAmount = positiveMeasurements.length - negativeMeasurements.length;
        } else {
          for (let j = 0; j < filteredMeasurements.length; j++) {
            totalMeasurementPrice += filteredMeasurements[j].price;
          }
          tempTotal = totalMeasurementPrice;
          tempAmount = filteredMeasurements.length;
        }
        for (let j = 0; j < filteredMeasurements.length; j++) {
          if (new Date(filteredMeasurements[j].insertedOn) < lowestDate) {
            lowestDate = new Date(filteredMeasurements[j].insertedOn);
          }
        }
        let highestDate = new Date(filteredMeasurements[0].insertedOn);
        for (let j = 0; j < filteredMeasurements.length; j++) {
          if (new Date(filteredMeasurements[j].insertedOn) > highestDate) {
            highestDate = new Date(filteredMeasurements[j].insertedOn);
          }
        }

        tempPriceData.push({
          price: thisProject.details[i].price !== null ? thisProject.details[i].price : 0,
          totalPrice: tempTotal,
          isProfit: thisProject.details[i].isProfit !== null ? thisProject.details[i].isProfit : true,
          detailDescription: thisProject.details[i].description,
          first: lowestDate,
          last: highestDate,
          amount: tempAmount,
          color: thisProject.details[i].color,
          type: detailType,
          minuteamount: detailType !== 2 ? null : convertHMS(totalTime),
        });
        if (thisProject.details[i].isProfit) {
          total += tempTotal;
        } else {
          total -= tempTotal;
        }
      }
    }
    tempPriceData = tempPriceData.filter((x) => x.totalPrice > 0);

    setTotalPrice(total);
    setPriceData(tempPriceData);
  };

  const constructFromAndToDate = (measurementData) => {
    let tempToDate;
    if (measurementData.length > 0) {
      tempToDate = new Date(measurementData[measurementData.length - 1].insertedOn);
    } else {
      tempToDate = new Date();
    }
    let tempFromDate = new Date(tempToDate - 86400000);
    return [tempFromDate, tempToDate];
  };

  const handlePreviousDay = () => {
    let tempFrom = timeRangeDates.fromDate;
    let tempTo = timeRangeDates.toDate;
    let newFromDate = new Date(new Date(tempFrom) - 24 * 60 * 60 * 1000);
    let newToDate = new Date(new Date(tempTo) - 24 * 60 * 60 * 1000);
    setTimeRangeDates({ startDate: newFromDate, fromDate: newFromDate, toDate: newToDate, endDate: newToDate });
    handleDifferentDate(newFromDate, newToDate);
  };

  const handleNextDay = () => {
    var duplicateDateRange = JSON.parse(JSON.stringify(timeRangeDates));
    let tempFrom = new Date(duplicateDateRange.fromDate);
    let tempTo = new Date(duplicateDateRange.toDate);
    let newFromDate = new Date(new Date(tempFrom).getTime() + 60 * 60 * 24 * 1000);
    let newToDate = new Date(new Date(tempTo).getTime() + 60 * 60 * 24 * 1000);
    setTimeRangeDates({ startDate: newFromDate, fromDate: newFromDate, toDate: newToDate, endDate: newToDate });
    handleDifferentDate(newFromDate, newToDate);
  };

  const navigateToModifyDetail = () => {
    navigate(`/modifyproject/${projectQr}`);
  };

  const handleDifferentDate = (tempFromDate, tempToDate) => {
    let thisProject = project;
    let tempMeasurementsCollection = [];
    let chartMeasurementCollection = [];

    //Loop through all details and just toss all measurements together, afterwards flatten and sort by date
    for (let i = 0; i < thisProject.details.length; i++) {
      tempMeasurementsCollection.push(thisProject.details[i].measurements);
    }

    tempMeasurementsCollection = tempMeasurementsCollection.flat();
    tempMeasurementsCollection = tempMeasurementsCollection.sort((a, b) => new Date(a.insertedOn) - new Date(b.insertedOn));
    chartMeasurementCollection = tempMeasurementsCollection.filter(
      (x) =>
        (new Date(x.insertedOn) >= new Date(tempFromDate) && new Date(x.insertedOn) <= new Date(tempToDate)) ||
        (new Date(x.endDate) >= new Date(tempFromDate) && new Date(x.endDate) <= new Date(tempToDate))
    );
    constructPriceData(thisProject, tempFromDate, tempToDate);

    //Creates an object with all detail and their color (needed for the chart)
    let projectDetails = thisProject.details;

    //Creates an object with all detail and their color (needed for the chart)
    let detailNames = constructDetailCollection(projectDetails);

    //Construct the data that will be displayed in the financial chart
    let tempChartData = constructChartData(projectDetails, chartMeasurementCollection);
    setDetailsNames(detailNames);
    setFinancialChartData(tempChartData);
  };

  const updateDataRange = (data, changeDay) => {
    let tempFromDate = new Date(data[0]);
    let tempToDate = new Date(data[1]);
    var duplicateDateRange = JSON.parse(JSON.stringify(timeRangeDates));

    handleDifferentDate(tempFromDate, tempToDate);
    var objNewTimeRangeDate;

    if (changeDay) {
      objNewTimeRangeDate = { startDate: new Date(tempFromDate), fromDate: new Date(tempFromDate), toDate: new Date(tempToDate), endDate: new Date(tempToDate) };
      //If the dateRanges are different --> setTimeRangeDates (to prevent that we set to many states)
    } else {
      objNewTimeRangeDate = { startDate: new Date(duplicateDateRange.startDate), fromDate: new Date(tempFromDate), toDate: new Date(tempToDate), endDate: new Date(duplicateDateRange.endDate) };
    }

    if (JSON.stringify(objNewTimeRangeDate) !== JSON.stringify(timeRangeDates)) {
      setTimeRangeDates(objNewTimeRangeDate);
    }
  };

  const handleDownloadImage = async (toDownload) => {
    let element;
    let fileName;
    if (toDownload === "HighLow") {
      element = HighLowRef.current;
      fileName = "HighLow.jpg";
    } else {
      element = ref.current;
      fileName = "Summary.jpg";
    }
    const canvas = await html2canvas(element);

    const data = canvas.toDataURL("image/jpg");
    const link = document.createElement("a");

    if (typeof link.download === "string") {
      link.href = data;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(data);
    }
  };

  const getControlTypeIcon = (typeId) => {
    let icon;
    switch (typeId) {
      case controlTypes.COUNTER:
        icon = <DiamondPlus className={classes.icon} />;
        break;
      case controlTypes.STOPWATCH:
        icon = <Timer className={classes.icon} />;
        break;
      case controlTypes.FREETEXT:
        icon = <TextCursorInput className={classes.icon} />;
        break;
      case controlTypes.DATALIST:
        icon = <List className={classes.icon} />;
        break;
      case controlTypes.SCANNER:
        icon = <ScanBarcode className={classes.icon} />;
        break;
      case controlTypes.CAMERA:
        icon = <Image className={classes.icon} />;
        break;
      case controlTypes.EXTERNALAPI:
        icon = <LinkIcon className={classes.icon} />;
        break;
      default:
      // code block
    }
    return icon;
  };

  return (
    <React.Fragment>
      <TitlePage Text="Financial dashboard" backbutton={true} {...props} />
      <Box
        sx={{
          maxWidth: "90%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          marginRight: "auto",
          marginLeft: "auto",
          marginTop: "148px",
        }}
      >
        <div className={classes.header}>
          <button className={classes.backButton} onClick={() => navigate("/projectreportoverview")}>
            <ChevronLeft className={classes.backButton__icon} />
            Back to project overview
          </button>
          <h1>Financial dashboard</h1>
        </div>
        {project !== null && (
          <div className={classes.fullHeader}>
            <h2 className={classes.projectTitle}>{project.projectName}</h2>
            <div className={classes.header__detailContainer}>
              <div className={classes.header__detail}>
                <MapPin className={classes.header__detailIcon} />
                <p className={classes.header__detailText}>{project.resourceDescription}</p>
              </div>
              <div className={classes.header__detail}>
                <Factory className={classes.header__detailIcon} />
                <p className={classes.header__detailText}>{project.companyName}</p>
              </div>
            </div>
          </div>
        )}

        <div className={classes.financialDashboardStyle}>
          <Box className={classes.boxStyle} ref={HighLowRef}>
            <Box className={classes.filterTitle} variant="contained" content="Options">
              <span>High/Low for this project</span>
              <Button style={{ backgroundColor: "white", color: "#C3996B" }} onClick={() => handleDownloadImage("HighLow")} data-html2canvas-ignore="true">
                Export
              </Button>
            </Box>

            {isLoading ? (
              <Box className={classes.loadingBalls}>
                <Spin width="100px" height="100px" color="#C3996B"></Spin>
              </Box>
            ) : project ? (
              project.details.map((detail, index) => {
                if (detail.measurements.length > 0 && detail.measurements.some((x) => x.price > 0)) {
                  return (
                    <Box key={`TableHighLow_${detail.id}_${index}`} className={classes.highLowItem}>
                      <div className={classes.highLow__headerContainer}>
                        <div className={classes.highLow__detailHeader}>
                          {getControlTypeIcon(detail.controlTypeId)}
                          <p className={classes.highLow__detailTitle}>{detail.description}</p>
                        </div>
                        {detail.isProfit ? <Plus style={{ color: "rgb(40, 167, 69)", paddingRight: "10px" }} /> : <Minus style={{ color: "rgb(220, 53, 69)", paddingRight: "10px" }} />}
                      </div>
                      <Divider></Divider>
                      <TableHighLow {...props} detail={detail} projectName={project.projectName} currency={currency} location={project.resourceDescription} projectQr={projectQr} />
                    </Box>
                  );
                } else {
                  return <React.Fragment></React.Fragment>;
                }
              })
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {measurementRows.length === 0 && !isLoading && (
              <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", height: "100%", justifyContent: "center" }}>
                <div className={classes.emptyStateCard}>
                  <p className={classes.emptyStateCard__title}>No events</p>
                  <p className={classes.emptyStateCard__subtitle}>There are no events for this project yet.</p>
                </div>
              </Box>
            )}
          </Box>
          {isLoading ? (
            <div className={classes.loadingChart}>
              <Spin width="100px" height="100px" color="#C3996B"></Spin>
            </div>
          ) : (
            <div className={classes.rightSideStyle}>
              <div className={classes.rightSideTitle}>
                Data between {parseNewDateToDDMMYYY(timeRangeDates.fromDate)} and {parseNewDateToDDMMYYY(timeRangeDates.toDate)}
              </div>
              <div style={{ backgroundColor: "white", marginBottom: "15px", borderRadius: "8px", padding: "16px", margin: "15px" }}>
                {project ? (
                  <TimeRangeChart updateDataRange={updateDataRange} handleNextDay={handleNextDay} handlePreviousDay={handlePreviousDay} timeRangeDates={timeRangeDates}></TimeRangeChart>
                ) : (
                  <div style={{ marginBottom: "40px" }}></div>
                )}
              </div>

              {financialChartData !== undefined && financialChartData.length > 0 ? (
                <div className={classes.financialChart}>
                  <FinancialChart
                    financialChartData={financialChartData}
                    projectDetailNames={projectDetailNames}
                    project={project}
                    currency={currency}
                    from={parseNewDateToDDMMYYYWithoutSeconds(timeRangeDates.fromDate)}
                    to={parseNewDateToDDMMYYYWithoutSeconds(timeRangeDates.toDate)}
                  ></FinancialChart>
                </div>
              ) : (
                <div style={{ backgroundColor: "white", height: "91%", padding: "25px", borderRadius: "8px", margin: "15px" }}>
                  <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                    <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                      <div className={classes.noDataIcons}>
                        <img className={classes.imageStyle} src={pieChart} alt="" />
                        <CircleAlert style={{ width: "100px", height: "100px", color: "#dc3545", position: "absolute", right: "0", bottom: "0" }} className={classes.CircleAlert}></CircleAlert>
                      </div>
                      <p style={{ marginTop: "36px", fontSize: "16px", color: "rgba(12, 14, 41, 1)" }}>
                        No data to display between {parseNewDateToDDMMYYY(timeRangeDates.fromDate)} and {parseNewDateToDDMMYYY(timeRangeDates.toDate)}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {priceData !== undefined && financialChartData.length > 0 ? (
                <div className={classes.chartBoxStyle}>
                  <div className={classes.pieStyle}>
                    {priceData.filter((x) => x.type !== 2).length > 0 ? (
                      <EventChart data={priceData.filter((x) => x.type !== 2 && x.price > 0)} title={"Event overview"} />
                    ) : (
                      <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                        <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                          <div className={classes.noDataIcons}>
                            <img className={classes.imageStyle} src={pieChart} alt="" />
                            <CircleAlert style={{ width: "100px", height: "100px", color: "#dc3545", position: "absolute", right: "0", bottom: "0" }} className={classes.CircleAlert}></CircleAlert>
                          </div>
                          <p style={{ marginTop: "30px" }}>There were no event measurements during this timespan</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={classes.pieStyle}>
                    {priceData.filter((x) => x.type === 2).length > 0 ? (
                      <EventChart data={priceData.filter((x) => x.type === 2)} title={"Time overview"} />
                    ) : (
                      <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                        <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                          <div className={classes.noDataIcons}>
                            <img className={classes.imageStyle} src={pieChart} alt="" />
                            <CircleAlert style={{ width: "100px", height: "100px", color: "#dc3545", position: "absolute", right: "0", bottom: "0" }} className={classes.CircleAlert}></CircleAlert>
                          </div>
                          <p style={{ marginTop: "30px" }}>There were no stopwatch measurements during this timespan</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className={classes.tableContainer} ref={ref}>
                <div className={classes.calculateBoxStyle}>
                  <div className={classes.filterTitle} variant="contained" content="Options">
                    <span>Summary</span>
                    <div>
                      <Button style={{ backgroundColor: "white", color: "#C3996B", marginRight: "10px" }} onClick={() => handleDownloadImage("Summary")} data-html2canvas-ignore="true">
                        Export
                      </Button>
                      <Button onClick={() => navigateToModifyDetail(project.id)} style={{ backgroundColor: "white", color: "#C3996B" }}>
                        Modify
                      </Button>
                    </div>
                  </div>

                  <div>
                    <PriceTable totalPrice={totalPrice} priceData={priceData} currency={currency}></PriceTable>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Box>
    </React.Fragment>
  );
}
export default ProjectReportPage;

const useStyles = makeStyles((theme) => ({
  header: {
    width: "100%",
    height: "40px",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    marginBottom: "16px",
  },

  backButton: {
    position: "absolute",
    top: "129px",

    display: "flex",
    alignItems: "center",
    gap: "4px",

    fontFamily: "Lato, sans-serif",
    fontSize: "14px",
    color: "#0C0E29",
    opacity: ".8",

    border: "none",
    padding: "0px",

    transition: "opacity ease-in-out .1s",

    "&:hover": {
      opacity: "1",
      cursor: "pointer",
    },
  },

  backButton__icon: {
    height: "16px",
    width: "16px",

    strokeWidth: "1.4px",
  },

  noDataAvailable: {
    width: "100%",
    backgroundColor: "white",
    borderRadius: "8px",
    fontSize: "20px",
    marginRight: "auto",
    marginLeft: "auto",
    paddingTop: "20px",
    paddingBottom: "20px",
    color: "#dc3545",
    paddingLeft: "15px",
  },
  bar: {
    [theme.breakpoints.up("lg")]: {
      minWidth: "70%",
    },
    [theme.breakpoints.down("lg")]: {
      minWidth: "60%",
    },
    [theme.breakpoints.down("md")]: {
      minWidth: "65%",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "70%",
    },
  },
  projectHeader: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "16px",
  },

  fullHeader: {
    width: "100%",
    boxSizing: "border-box",

    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "8px",

    backgroundColor: "#C3996B",
    color: "white",

    borderRadius: "8px",

    padding: "16px",
    marginBottom: "16px",
  },

  projectTitle: {
    color: "white",
  },

  header__detailContainer: {
    display: "flex",
    gap: "24px",
  },

  header__detail: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  header__detailIcon: {
    width: "20px",
    height: "20px",

    strokeWidth: "1.4px",

    display: "block",
  },

  header__detailText: {
    margin: "0px",
  },

  extraInfo: {
    display: "flex",
    justifyContent: "end",
  },

  financialDashboardStyle: {
    display: "flex",
    width: "100%",

    height: "100%",

    marginRight: "auto",
    marginLeft: "auto",
    marginBottom: "16px",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  container: {
    boxSizing: "border-box",

    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    flexFlow: "space-around",
    borderRadius: "8px",
    gap: "20px 30px",
    width: "70%",
    // [theme.breakpoints.up('lg')]: {
    //     maxWidth: "70%",
    // },
    // [theme.breakpoints.down('lg')]: {
    //     maxWidth: "70%",
    // },
    // [theme.breakpoints.down('md')]: {
    //     maxWidth: "90%",
    // },
    marginRight: "auto",
    marginLeft: "auto",
    marginTop: "25px",
  },
  titleTextStyle: {
    display: "flex",
    marginLeft: "20px",
  },
  noDataIcons: {
    position: "relative",
  },
  CircleAlert: {
    position: "absolute",
    right: "25%",
    bottom: "25%",
  },
  imageStyle: {
    height: "100%",
    width: "100%",
    filter: "invert(87%) sepia(15%) saturate(124%) hue-rotate(341deg) brightness(108%) contrast(86%)",
  },
  noHighLow: {
    height: "100px",
    width: "100px",
    marginTop: "15px",
  },
  boxStyle: {
    // height: 'calc(100vh + 15px)',
    overflowY: "hidden",
    width: "30%",

    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginBottom: "15px",
    },
    display: "flex",
    flexDirection: "column",
    background: "#FFFFFF",
    borderRadius: "8px",
    marginRight: "15px",
    //minHeight: '1000px'
  },
  loadingBalls: {
    height: "100%",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  loadingChart: {
    height: "100vh",
    width: "70%",
    position: "relative",
    zIndex: "999",
    borderRadius: "8px",
    backgroundColor: "white",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  detailHeader: {
    fontSize: "16px",
    fontWeight: "600",
    padding: "10px",
    display: "flex",
    alignItems: "center",
  },

  highLow__headerContainer: {
    width: "100%",

    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    flexDirection: "row",
    backgroundColor: "#ede6df",
  },

  highLow__detailHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",

    fontSize: "16px",
    fontWeight: "600",

    padding: "10px",
  },

  highLow__detailTitle: {
    margin: "0",
  },

  rightSideStyle: {
    borderRadius: "8px",
    height: "100%",
    width: "70%",

    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    position: "relative",
    background: "#ede6df",
  },
  chartBoxStyle: {
    height: "50%",
    margin: "15px",
    overflow: "hidden",
    display: "flex",
    gap: "16px",
    flexGrow: "2",
    justifyContent: "space-between",
    flexDirection: "row",
    borderRadius: "8px",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "calc(100% - 30px)",
    },
  },
  tableContainer: {
    margin: "15px",
  },

  financialChart: {
    boxSizing: "border-box",

    backgroundColor: "white",
    borderRadius: "8px",

    padding: "16px",
    margin: "16px",
  },

  pieStyle: {
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: "15px",
    },
    background: "#FFFFFF",
    borderRadius: "8px",
    padding: "18px",
  },

  highLowItem: {
    display: "flex",
    flexDirection: "column",
  },

  calculateBoxStyle: {
    overflow: "hidden",
    display: "flex",
    flexGrow: "3",
    justifyContent: "space-between",
    flexDirection: "column",
    background: "#FFFFFF",
    borderRadius: "8px",
    padding: "18px",
    gap: "10px",
  },

  filterTitle: {
    backgroundColor: "#C3996B !important",
    color: "white",
    fontSize: "18px",
    fontWeight: "500",
    padding: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
  },
  rightSideTitle: {
    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",

    backgroundColor: "#C3996B !important",
    color: "white",
    fontSize: "18px",
    fontWeight: "500",
    padding: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
  },
  stylingBlock: {
    backgroundColor: "#f0f0f0",
    borderRadius: "6px",
    boxShadow: "inset -3px -3px 7px #ffffffb0, inset 3px 3px 5px rgba(94, 104, 121, 0.692)",
    padding: "25px",
  },
  filterBlock: {
    display: "flex",
    marginBottom: "15px",
    flexWrap: "wrap",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "space-around",
      gap: "15px",
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-evenly",
    },
  },

  emptyStateCard: {
    maxWidth: "320px",
    boxSizing: "border-box",

    padding: "16px",
    margin: "auto",

    display: "flex",
    flexDirection: "column",

    alignItems: "center",

    backgroundColor: "transparent",
  },

  emptyStateCard__title: {
    fontFamily: "Lato, sans-serif",
    fontSize: "16px",
    color: "rgba(12, 14, 41, 1)",

    margin: "0px",
    marginBottom: "8px",
  },

  emptyStateCard__subtitle: {
    fontFamily: "Lato, sans-serif",
    fontSize: "14px",
    color: "rgba(12, 14, 41, 0.8)",

    textAlign: "center",

    margin: "0px",
  },

  icon: {
    color: "#0C0E29",
    display: "block",

    height: "24px",
    width: "24px",

    strokeWidth: "1.8px",
  },
}));
